module.exports = __webpack_public_path__ + "static/media/2-_DSC9286.7c173162.jpg";